/**
 * PATH: apps/assets/src/pages/DashboardPage.tsx
 * PURPOSE: Assets Hub Dashboard
 */
import { EmptyRegister } from './emptyRegister'

export default function DashboardPage() {
  return (
    <EmptyRegister
      title="Assets Dashboard"
      detail="No asset totals are connected."
    />
  )
}
